export default {
  progress: {
    width: '550px',
    margin: '0 auto'
  }
};
